import React from 'react'
import { Flex, Text, useAppTheme, Button, Link } from '@workwhile/ui'
import { useBookingDetailsContextValue } from '../../../context/BookingDetailsProvider'
import { useBookingShiftDetailContextValue } from '../context/BookingShiftDetailProvider'
import * as ROUTES from 'constants/routes'
import { Workers } from '../../Workers'
import { DayforceRequestedWorkers } from '../../DayforceRequestedWorkers'
import { DayforceShiftAssociationTypes } from 'pages/Dayforce/constants'

export const BookingShiftDetailMain = () => {
  const { space } = useAppTheme()

  const {
    state: { dayforceBooking },
  } = useBookingDetailsContextValue()

  const {
    state: { workWhileShift, associationType, shiftIdx },
  } = useBookingShiftDetailContextValue()

  const bizPortalShiftDetailsUrl =
    dayforceBooking.companyId && workWhileShift.id
      ? `${ROUTES.COMPANY_SWITCH.replace(
          ':companyId',
          dayforceBooking.companyId.toString()
        )}?redirectUrl=${encodeURIComponent(
          `https://business.workwhilejobs.com/shift/${workWhileShift.id}`
        )}`
      : undefined

  return (
    <Flex flexDirection="column" gap={2}>
      <Flex
        alignItems="center"
        flexDirection="row"
        justifyContent="space-between"
        gap={2}
      >
        <Text fontWeight="bold">
          Shift {shiftIdx + 1}/{dayforceBooking.shifts.length} -{' '}
          {workWhileShift.id} -{' '}
          {DayforceShiftAssociationTypes?.[associationType] ?? associationType}
        </Text>
        <Flex alignItems="center" flexDirection="row" gap={2}>
          <Button
            as={Link}
            to={ROUTES.SHIFT_DETAIL.replace(
              ':shiftId',
              workWhileShift.id.toString()
            )}
            variant="text"
            kind="small"
          >
            Admin
          </Button>
          {bizPortalShiftDetailsUrl ? (
            <Button
              as="a"
              href={bizPortalShiftDetailsUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="secondary"
              kind="small"
            >
              Biz portal
            </Button>
          ) : null}
        </Flex>
      </Flex>
      <Text>
        <Text as="span" fontWeight="bold">
          Company ID:{' '}
        </Text>
        {dayforceBooking.companyId}
      </Text>
      <Text>
        <Text as="span" fontWeight="bold">
          Shift ID:{' '}
        </Text>
        {workWhileShift.id} ({associationType})
      </Text>
      <Text>
        <Text as="span" fontWeight="bold">
          WW Fill:{' '}
        </Text>
        {workWhileShift?.numScheduleRateWorkers} /{' '}
        {workWhileShift?.workersNeeded}
      </Text>
      <Text>
        <Text as="span" fontWeight="bold">
          WW Cushion:{' '}
        </Text>
        {workWhileShift?.numCushionWorkersFilled} /{' '}
        {workWhileShift?.numCushionWorkersNeeded}
      </Text>
      <Flex flexDirection="column" gap={space[3]}>
        <Workers />
        <DayforceRequestedWorkers />
      </Flex>
    </Flex>
  )
}
